export const NEST_SERVER_URL = 'https://dev-sus-api.softlight.com.ar'
export const CREDENTIALS_MP = {
  public_key :'APP_USR-a1894c2b-5b69-4278-8ed4-b736c3a72700',
  locale: 'es-AR'
}